import { LandingPageContent, productCards } from './types';

export const landingPageContent: LandingPageContent = {
  companyHeader: {
    companyName: 'vMonad',
    tagLine: 'Media generation as a compute primitive',
    tagLine2: 'Cloud Scale, Open-source, Composable'
  },
  heroSection: {
    id: 'hero',
    title: 'Transform Your Content with AI',
    description: 'Create engaging, interactive content experiences powered by artificial intelligence. Turn your ideas into immersive stories.',
    ctaText: 'Get Started',
    ctaAction: '/get-started',
    fullHeight: true
  },
  productsSection: {
    id: 'products',
    title: 'Media infrastructure for AI agents',
    header: 'Create audio, video, games, and worlds using an open, agent-first platform designed for autonomous media creation.',
    subHeader: 'Open-source • Multi-modal • API-first',
    categoryTerm: '',
    closingLine: '',
    products: productCards
  },
  featuresSections: [
    {
      id: 'main-features',
      title: 'Why Choose Us',
      features: [
        {
          icon: '/static/images/ai-icon.svg',
          title: 'AI-Powered Creation',
          description: 'Leverage advanced AI to transform your content into interactive experiences.'
        },
        {
          icon: '/static/images/interactive-icon.svg',
          title: 'Interactive Engagement',
          description: 'Create immersive experiences that keep your audience engaged.'
        },
        {
          icon: '/static/images/analytics-icon.svg',
          title: 'Deep Analytics',
          description: 'Gain insights into how your audience interacts with your content.'
        }
      ]
    }
  ]
};
